<template>
    <div class="all">
      <Head></Head>
      <div class="tesegou">
        <!--<div class="tesegou_left">
          <img src="../assets/yjdz.png" alt="">
          <div v-for="(item,key) in list" :key="key" @click="anchorJump(item.id)">
            <p>{{item.name}}</p>
          </div>
        </div>-->
        <div class="tesegou_right">
          <div class="tesegou_right_img">
            <img src="../assets/yizhandingzhi.png" alt="">
          </div>
          <div class="tesegou_right_for" v-for="(item,key) in list1" :key="key">
            <div class="tesegou_right_for_title" v-if="item.goods">
              {{item.name}}
            </div>
            <div class="tesegou_right_for_shop">
              <div class="tesegou_right_for_shop_for" v-for="(ite,index) in item.goods" :key="index">
                <div>
                  <div>
                    <img :src="$store.state.Url+ite.img" alt="" @click="getxiangqing(ite.goods_id)">
                  </div>
                  <p class="tesegou_right_for_shop_for_p" @click="getxiangqing(ite.goods_id)">{{ite.name}}</p>
                  <p>全友价: <span>￥{{ite.price}}</span></p>
                  <button @click="getShoping(item.goods_id)">购买</button>
                  <button @click="getShoucang(0)">收藏</button>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      <!--<div style="text-align: center;margin-top: 30px;">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          @current-change="getchange1"
          :total="total"
        >
        </el-pagination>
      </div>-->
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import {getntesegou} from '../api/index'
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getaddcollection, getquxiaocollection, getshopping} from "../api/List";
    export default {
        name: "tesegou",
      components:{
        Pagetail,Head
      },
      data(){
          return{
            list:[],
            list1:[],
            total:'',
            pagesize:18,
            num:18,
            page:1,
          }
      },
      mounted() {
          this.init()
        window.addEventListener("scroll", this.handleScroll);
      },
      methods:{
        getchange(val){
          console.log(val)
        },
        getchange1(val){
          this.page = val
          this.init()
          console.log(val)
        },
        getxiangqing(id){
          console.log(id)
          this.$router.push({path:'/details',query:{id:id,status:2}})
        },
        getShoping(id){
          if (this.$store.state.user.token){
            getshopping({
              goods_id:id,
              num:1
            }).then(res=>{

            })
          }else {
            this.$message('请登录');
          }
        },
        getShoucang(e){
          if (this.$store.state.user.token){
            if (e == 0){
              //  Foc/add_collection  添加收藏,goods_id,status
              getaddcollection({
                goods_id:this.$route.query.id,//
                status:this.$route.query.status,//
              }).then(res=>{
                this.init()
              })
            }else {
              // quxiao_collection 取消收藏, goods_id,status
              getquxiaocollection({
                goods_id:this.$route.query.id,//
                status:this.$route.query.status,//
              }).then(res=>{
                this.init()
              })
            }
          }else {
            this.$message('请登录');
          }

        },
        anchorJump(id) {
          document.querySelector("#ss" + id).scrollIntoView(true);
        },
          init(){
            getntesegou({
              id:this.$route.query.id,
              num:this.num,
              page:this.page
            }).then(res=>{
              this.list = res.two_class
              this.list1 = res.result
              this.total = res.count
            })
          },
        handleScroll() {
          var scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          if (scrollTop > 340) {
            this.searchBarFixed = true;
          } else {
            this.searchBarFixed = false;
          }
        },
      }
    }
</script>

<style scoped lang="less">
  @import "css/tesegou";
</style>



// WEBPACK FOOTER //
// src/components/tesegou.vue